// 
const baseUrl = "https://cl.newagemedia.co.ke/api/";

// const baseUrl = "http://localhost/projects/CityLiquorApi/";

export default baseUrl;